import axios from "axios";
import { ResendConfirmationReq } from "redmond";

import { config } from "../../config";

import { resendLatestEmailPath } from "../paths";

const resendConfirmationEmail = async (
  req: ResendConfirmationReq
): Promise<void> => {
  // If this throws an error, the Promise returned by the function will reject with that error
  await axios.post(resendLatestEmailPath, req, {
    baseURL: config.baseURL,
  });
};

export default resendConfirmationEmail;
